import { useEffect, useMemo } from 'react';
import { setLocale, ObjectSchema } from 'yup';
import { useTranslation } from 'react-i18next';
import { FieldValues } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { useAppConfig } from '@/redux/features/app-config/hooks';

const useSchema = <T extends FieldValues>(getSchema: () => ObjectSchema<T>) => {
  const { t } = useTranslation();
  const { locale } = useAppConfig();

  useEffect(() => {
    setLocale({
      mixed: {
        default: t('label.form.invalid'),
        required: t('label.form.required'),
      },
      string: {
        matches: ({ regex }) => t('label.form.matches', { pattern: regex }),
      },
    });
  }, [t, locale]);

  return useMemo(() => {
    const schema = getSchema();

    return yupResolver(schema);
  }, [getSchema]);
};

export default useSchema;
